module.exports = __webpack_public_path__ + "static/progression-casestudy-96b275c0046aff371aafc71c1e84f28a.pdf";